import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-change-name',
  templateUrl: './change-name.page.html',
  styleUrls: ['./change-name.page.scss']
})
export class ChangeNamePage implements OnInit {

  en_changeUser = 'Change Your Username';
  en_saveButton = 'Save';

  sp_changeUser = 'Cambia tu Nombre de Usuario';
  sp_saveButton = 'Guardar';

  language: string;

  constructor(private _viewCtrl: ModalController, private _params: NavParams) {
  }

  async ngOnInit() {
    this.language = this._params.get('language');
    this.didEnter();
  }

  didEnter() {
    const text = document.getElementsByClassName('to_hide_text') as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < text.length; i++) { text[i].classList.add('anim'); }
  }

  goBack() {
    this._viewCtrl.dismiss();
  }

}
